import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, LogIn } from "lucide-react";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { LOGO_ROUND } from "../../mock";
import { useSeo } from "../../hooks/useSeo";

const AdminLogin = () => {
  const { login } = useAdminAuth();
  useSeo({ title: "Admin Login", noindex: true });
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0d281d] px-4">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 shadow-2xl">
        <div className="mb-6 flex flex-col items-center text-center">
          <img src={LOGO_ROUND} alt="British Supplements" className="h-20 w-20 rounded-full object-cover ring-1 ring-[#e3efe7]" />
          <h1 className="mt-4 font-display text-2xl font-bold uppercase text-[#1B4332]">Admin Login</h1>
          <p className="mt-1 text-sm text-[#6b7d72]">British Supplements control panel</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="mb-1 block font-display text-xs font-semibold uppercase tracking-wider text-[#2D6A4F]">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full rounded-xl border border-[#dceadf] px-4 py-3 outline-none focus:border-[#52B788]" />
          </div>
          <div>
            <label className="mb-1 block font-display text-xs font-semibold uppercase tracking-wider text-[#2D6A4F]">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full rounded-xl border border-[#dceadf] px-4 py-3 outline-none focus:border-[#52B788]" />
          </div>
          {error && <p className="rounded-lg bg-[#fbe9e9] px-4 py-2 text-sm text-[#c1121f]">{error}</p>}
          <button type="submit" disabled={busy}
            className="flex w-full items-center justify-center gap-2 rounded-full bg-[#2D6A4F] py-3.5 font-display text-sm font-bold uppercase tracking-wider text-white transition hover:bg-[#1B4332] disabled:opacity-60">
            {busy ? <Loader2 size={18} className="animate-spin" /> : <LogIn size={18} />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
